const siteMetadata = require('./src/data/siteMetaData');

module.exports = {
  siteMetadata,
  plugins: [
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-resolve-src',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
    `gatsby-transformer-remark`,
    'gatsby-transformer-sharp',
    `gatsby-transformer-yaml`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `img`,
        path: `${__dirname}/src/assets/images/`
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `contents`,
        path: `${__dirname}/src/locale/`
      },
    },
    {
      resolve: `gatsby-plugin-nprogress`,
      options: {
        color: `tomato`,
        showSpinner: false,
      },
    },
    {
      resolve: 'gatsby-plugin-i18n',
      options: {
        langKeyForNull: 'en',
        langKeyDefault: siteMetadata.languages.defaultLangKey,
        useLangKeyLayout: true
      }
    },
    `gatsby-plugin-offline`,
    {
      resolve: 'gatsby-plugin-mailchimp',
      options: {
        endpoint: 'https://scichess.us18.list-manage.com/subscribe/post?u=6830e874b8a64905dce7074fb&amp;id=fc5a908323',
      },
    },
  ]
}



// WEBPACK FOOTER //
// ./gatsby-config.js